<template>
  <div>
    <div>
      <p>Are you sure you want to delete <strong><u>ALL</u></strong> deployments for the <strong>{{ data.name }}</strong> department?</p>
      <div class="row">
        <div class="col-md-6 pull-right" style="padding-top: 34px;">
          <div v-if="isSaving" style="text-align: right;">
            <img src="static/img/loading-2.gif" width="30px" height="30px" />
          </div>
          <div v-if="isSuccess" style="text-align: right;">
            <img src="static/img/active-true.png" width="30px" height="30px" />
          </div>
          <div v-if="isFailed" style="text-align: right;">
            <img src="static/img/active-error.png" width="30px" height="30px" />
          </div>
        </div>
        <div class="col-md-6">
          <div id="btn-submit">
            <button @click="validateAndSubmit" class="btn btn-fill btn-info btn-save pull-right" :disabled="isSaving">Yes</button>
            <button @click="() => $emit('close')" class="btn btn-fill btn-info btn-save pull-right" :disabled="isSaving">No</button>
          </div>
        </div>
      </div>
    </div>
    <div style="clear:both"></div>
  </div>
</template>

<script>
  import { notifySuccess, notifyError } from 'src/utilities/utils'
  import {NO_CONTENT} from 'http-status-codes'

  const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  const STATUS_SUCCESS = 2
  const STATUS_FAILED = 3

  export default {
    props: ['data'],
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED
      }
    },
    data () {
      return {
        currentStatus: null
      }
    },
    methods: {
      statusInitial() {
        this.currentStatus = STATUS_INITIAL
      },
      async validateAndSubmit() {
        this.currentStatus = STATUS_SAVING
        if (await this.$validator.validateAll()) {
          const response = await this.$store.dispatch('camunda/deleteDeploymentsByDepartment', this.data.id)
          if (response.status === NO_CONTENT) {
            notifySuccess(this, 'Camunda Deployments Deleted Successfully')
            this.currentStatus = STATUS_SUCCESS
            this.$eventHub.$emit('refreshCamundaDeployments')
            this.$emit('close')
          } else {
            notifyError(this, 'Failed to delete Camunda Deployment(s)')
            this.currentStatus = STATUS_FAILED
          }
        }
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      }
    },
    mounted() {
      this.currentStatus = STATUS_INITIAL
    }
  }
</script>

<style scoped>
  #btn-submit {
    margin-top: 20px
  }
</style>
